'use strict';

pxco.imgs = {
	init: function init() {
		var imgs = document.querySelectorAll('[data-img-large], [data-img-medium], [data-img-small]');

		for (var i = 0; i < imgs.length; ++i) {
			var src = imgs[i].src,
			    medium = imgs[i].getAttribute('data-img-medium'),
			    small = imgs[i].getAttribute('data-img-small'),
			    large = imgs[i].getAttribute('data-img-large');

			if (!large) imgs[i].setAttribute('data-img-large', src);

			if (small && pxco.breakpoints.value == 'small') {
				imgs[i].src = small;
			} else if (medium && pxco.breakpoints.value == 'medium' || medium && pxco.breakpoints.value == 'small') {
				imgs[i].src = medium;
			} else {
				imgs[i].src = imgs[i].getAttribute('data-img-large');
			}
		}
	}
};
pxco.fnLoad('imgs');